import { Header } from "@/features/header";
import { useSteps } from "@/shared/hooks/useGetSteps";
import { Flex, message, Steps } from "antd";
import { type FC, type ReactNode } from "react";
import useDateTimeScreenStyles from "./ScreenWrapper.styles";
import { useFormContext, useWatch } from "react-hook-form";
import type { FormValues } from "@/pages/home-page/model/form.schema";
import type { PossibleStepsLabels } from "@/shared/lib/step.constants";

interface DateTimeScreenProps {
  children: ReactNode;
}

const ScreenWrapper: FC<DateTimeScreenProps> = ({ children }) => {
  const { styles } = useDateTimeScreenStyles();
  const { control } = useFormContext<FormValues>();
  const formValues = useWatch({ control });
  const { steps, goStep } = useSteps();

  const handleGoStep = (type: keyof typeof PossibleStepsLabels) => {
    if (steps[0].type === "dateTime") {
      if (type === "dateTime") {
        goStep("dateTime");
      }
      if (type === "employee") {
        if (formValues.date && formValues.start_time && formValues.end_time) {
          goStep("employee");
        } else {
          message.error("Выберите дату и время");
        }
      }
      if (type === "details") {
        if (formValues.employee_id) {
          goStep("details");
        } else {
          message.error("Сначала выберите специалиста");
        }
      }
    } else {
      if (type === "employee") {
        if (formValues.employee_id) {
          goStep("employee");
        } else {
          message.error("Выберите специалиста");
        }
      }
      if (type === "dateTime") {
        if (formValues.start_time && formValues.end_time && formValues.date) {
          goStep("dateTime");
        } else {
          message.error("Выберите дату и время");
        }
      }
      if (type === "details") {
      }
    }
  };

  return (
    <Flex className={styles.screen} vertical gap={8}>
      <Header />
      <Flex className={styles.stepWrapper}>
        <Steps
          items={steps.map((item) => ({
            ...item,
            className: styles.stepIconWrapper,
            onClick: () => {
              handleGoStep(item.type);
            },
          }))}
          responsive={false}
          labelPlacement="vertical"
          direction="horizontal"
        />
      </Flex>
      {children}
    </Flex>
  );
};
export default ScreenWrapper;
